// import styles from "./EmptyState.module.css";

// export default function EmptyState() {
//   return (
//     <section className={styles.container}>

//       <h2 className={styles.title}>
//         No Hotels Found
//       </h2>

//       <p className={styles.message}>
//         We couldn't find any hotels matching your selected location.
//         Please choose another state or city.
//       </p>
//     </section>
//   );
// }

import styles from "./EmptyState.module.css";

export default function EmptyState() {
  return (
    <section className={styles.container}>

      <h2 className={styles.title}>
Find Your Perfect Venue
      </h2>

      <p className={styles.message}>
          Select a state or city, or search for a hotel
              to discover venues for your next event.
      </p>
    </section>
  );
}